import { useEffect, useState } from "react";
import { fetchNews } from "../lib/api";
import { NewsDetailDialog } from "../components/NewsDetailDialog";

export default function Actualites() {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    fetchNews()
      .then((data) => { setNews(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div data-testid="page-actualites" className="pt-32 pb-20 px-6 md:px-12 lg:px-24 min-h-screen">
      <header className="mb-20 max-w-4xl">
        <p className="text-xs tracking-[0.3em] uppercase text-[#9E4735] font-body mb-6">
          La vie de la maison d'édition
        </p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl text-[#1A1A1A] leading-[1.05] tracking-tight font-light mb-8">
          Actualités
        </h1>
        <p className="text-lg text-[#4A4A4A] font-body leading-relaxed max-w-2xl">
          Concours, dédicaces, récitals, salons littéraires, sorties événement… Retrouvez ici tous les temps forts de Challenges Littéraires Éditions.
        </p>
      </header>

      {loading ? (
        <p className="text-[#757575] font-body" data-testid="loading-actualites">Chargement…</p>
      ) : news.length === 0 ? (
        <p className="text-[#757575] font-body" data-testid="no-actualites">Aucune actualité pour le moment.</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 md:gap-10">
          {news.map((item, i) => (
            <article
              key={item.id}
              onClick={() => setSelected(item)}
              data-testid={`actu-card-${item.id}`}
              style={{ animationDelay: `${i * 60}ms` }}
              className="group cursor-pointer bg-[#FAF9F6] border border-[#D1CFC7] hover:border-[#2C402E] transition-all fade-in-up"
            >
              {item.image_url && (
                <div className="relative bg-[#F4F1EA] aspect-[4/5] overflow-hidden">
                  <img
                    src={item.image_url}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                  {item.gallery && item.gallery.length > 1 && (
                    <span className="absolute bottom-3 right-3 bg-[#1A1A1A]/80 text-[#FAF9F6] text-[10px] tracking-[0.15em] uppercase px-2.5 py-1 font-body">
                      {item.gallery.length} photos
                    </span>
                  )}
                  {item.attachments && item.attachments.length > 0 && (
                    <span className="absolute top-3 right-3 bg-[#9E4735] text-[#FAF9F6] text-[10px] tracking-[0.15em] uppercase px-2.5 py-1 font-body">
                      {item.attachments.length} document{item.attachments.length > 1 ? "s" : ""}
                    </span>
                  )}
                </div>
              )}
              <div className="p-6">
                <p className="text-[10px] tracking-[0.25em] uppercase font-body text-[#9E4735] mb-3">
                  {item.category} · {new Date(item.date).toLocaleDateString("fr-FR", { year: "numeric", month: "long", day: "numeric" })}
                </p>
                <h3 className="font-serif text-xl md:text-2xl text-[#1A1A1A] leading-tight font-light mb-3 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-sm font-body text-[#4A4A4A] leading-relaxed line-clamp-3">
                  {item.excerpt}
                </p>
              </div>
            </article>
          ))}
        </div>
      )}

      <NewsDetailDialog item={selected} open={!!selected} onClose={() => setSelected(null)} />
    </div>
  );
}
